
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useState, useEffect } from "react";
import Header from "./components/Header/Header.js";
import Footer from "./components/Footer/Footer.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavBar from "./components/NavBar/NavBar.js";
import Home from "./components/Home/Home.js";
import Introduction from "./components/Introduction/Introduction.js";
import Definition from "./components/Definition/Definition.js";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import ContactUs from "./components/ContactUs/ContactUs.js";
import WhoWho from "./components/WhoWho/WhoWho.js";

import ActsRules from "./components/ActsRules/ActsRules.js";
import SainikSchool from "./components/SainikSchool/SainikSchool.js";
import RmsBangalore from "./components/Rms/RmsBanglore.js";

import RmsDholpur from "./components/Rms/RmsDholpur.js";
import RmsAjmer from "./components/Rms/RmsAjmer.js";
import RmsChail from "./components/Rms/RmsChail.js";

import RimcInfo from "./components/Rimc/Rimc.js";
import SainikSchoolKunjpura from "./components/Kunjpuraschl/SainikSchoolKunjpura.js";
import SainikSchoolGothraTappaKhori from "./components/SainikGothra/SainikGothra.js";
import SainikSchoolAsthal from "./components/Asthal/Asthal.js";
import SainikSchoolMajra from "./components/Majra/Majra.js";

import RmsKhera from "./components/rmsKhera/SainikSchoolKhera.js";
import Dsr from "./components/Dsr/Dsr.js";
import DonationPage from "./components/DonationPage/DonationPage.js";
import Login from "./components/Login/login.js";
import SainikSadan from "./components/SainikSadan/SainikSadan.js";
import SainikRestHouses from "./components/SainikRestHouses/SainikRestHouses.js";
import Organisation from "./components/Organisation/Organisation.js";
import WarMemorials from "./components/War Memorials/WarMemorials.js";
import Home1 from "./components/Dashboard/Home.js";
import Dashboard from "./components/Dashboard/Dashboard.js";
import Images from "./components/Dashboard/Images.js";
import Notifications from "./components/Dashboard/Notifications.js";
import Links from "./components/Dashboard/Links.js";
import AdministrativeSetup from "./components/AdministrativeSetup/AdministrativeSetup.js";
import NotificationOrder from "./components/NotificationOrder/NotificationOrder.js";
import BudgetFinance from "./components/BudgetFinance/BudgetFinance.js";
import Census2011 from "./components/Capf/Capf.js";
import Census2021 from "./components/Esm/Esm.js";
import RightInformation from "./components/RightInformation/RightInformation.js";
import RightService from "./components/RightService/RightService.js";
import CanteenStores from "./components/CanteenStores/CanteenStores.js";
import Forms from "./components/Forms/Forms.js";
import EsmAwardees from "./components/Awardees/EsmAwardees.js";
import CapfAwardees from "./components/Awardees/CapfAwardees.js";
import EsmMedalDetail from "./components/MedalDetail/EsmMedalDetail.js";
import CapfMedalDetail from "./components/MedalDetail/CapfMedalDetail.js";
import EsmMartyrsDetails from "./components/MartyrsDetails/EsmMartyrsDetails.js";
import CapfMartyrsDetails from "./components/MartyrsDetails/CapfMartyrsDetails.js";
import Esm from "./components/Esm/Esm.js";
import Capf from "./components/Capf/Capf.js";
import Grievances from "./components/Grievances/Grievances.js";
import WelfareScheme from "./components/Capf/WelfareScheme.js";
import Policies from "./components/Agniveer/Policies.js";
import Echs from "./components/CanteenStores/Echs.js";
import NotFound from "./NotFound.js";
import Loader from './components/Loader/Loader';
import { useSelector } from 'react-redux';
import Registration from "./components/Login/Registration.js";
import Registration2 from "./components/Dashboard/Registration.js";
import RegistrationSkill from "./components/Dashboard/RegistrationSkill.js";
import EsmMartyrs from "./components/Martyrs/EsmMartyrs.js";
import CapfMartyrs from "./components/Martyrs/CapfMartyrs.js";
import CapfRegistrationDistrictCounts from "./components/Capf/CapfRegistrationDistrictCounts.js";
import Application from "./components/Dashboard/Application.js";
import AdminApplicationView from "./components/Dashboard/AdminApplicationView.js";
import AdminApplicationSkillView from "./components/Dashboard/AdminApplicationSkillView.js";
import RegistrationFilter from "./components/Dashboard/RegistrationFilter.js";
import HqHome from "./components/Dashboard/HqHome.js";
import HqRegData from "./components/Dashboard/HqRegData.js";
import HqRegDataFilter from "./components/Dashboard/HqRegDataFilter.js";
import HodApplicationView from "./components/Dashboard/HodApplicationView.js";
import DsaswoManagement from "./components/Dashboard/DsaswoManagement.js";
import MandatoryDisclosure from "./components/RightInformation/MandatoryDisclosure.js";
import Reservation from "./components/Agniveer/Reservation.js";
import Notice from "./components/Agniveer/Notice.js";
import Brochure from "./components/WhoWho/Brochure.js";
import Policy from "./components/Capf/Policy.js";
import Amalgamated from "./components/Introduction/Amalgamated.js";
import Ranks from "./components/Capf/Ranks.js";
import CapfRegistration from "./components/Capf/Registration.js";
import EsmRegistration from "./components/Esm/Registration.js";
import SkillCourses from "./components/Capf/SkillCourses.js";
import Nalsa from "./components/SainikSadan/Nalsa.js";
import Media from "./components/RightInformation/Media.js";
import SkillCoursesPage from "./components/Capf/SkillCoursesPage.js";
import CapfRegistrationPage from "./components/Capf/CapfRegistrationPage.js";
import EsmRegistrationPage from "./components/Esm/EsmRegistrationPage.js";
import Register from "./components/Capf/Register.js";
import IdCard from "./components/Capf/IdCard.js";
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};


const AppContent = () => {

  const location = useLocation();
  const hideLayout = ["/dashboard", "/dashboard/home", "/dashboard/upload-images", "/dashboard/upload-notifications", "/dashboard/upload-links","/dashboard/application-form","/dashboard/registration-data","/dashboard/registration-data-skill","/dashboard/admin-registration-data","/dashboard/admin-registration-data-skill","/dashboard/district-registration-data","/dashboard/hq/home","/dashboard/hq/registration-data","/dashboard/hq/hq-registration-data","/dashboard/hq/admin-registration-data","/dashboard/hq/dsaswo-management","/dashboard/capf-registration","/dashboard/esm-registration","/dashboard/skill-courses"].includes(location.pathname);
  const [hasScrollbar, setHasScrollbar] = useState(false);
 const isLoading = useSelector((state) => state.loading.value)
  const checkScrollbar = () => {
    const hasVerticalScrollbar =
      document.documentElement.scrollHeight >= window.innerHeight;
    setHasScrollbar(hasVerticalScrollbar);
  };

  useEffect(() => {
    checkScrollbar();

    window.addEventListener("resize", checkScrollbar);
    return () => {
      window.removeEventListener("resize", checkScrollbar);
    };
  }, []);

  return (
    <>
      {!hideLayout && <Header />}
      {isLoading && <Loader />}
      <ScrollToTop />
      {!hideLayout && <NavBar />}
      <Routes>
        <Route path="/login" element={<Login />} />
         {/* <Route path="/registration" element={<Registration />} /> */}

        <Route path="dashboard" element={<Dashboard />}>
          <Route path="home" element={<Home1 />} />
          <Route path="upload-images" element={<Images />} />
          <Route path="upload-notifications" element={<Notifications />} />
          <Route path="upload-links" element={<Links />} />
          {/* <Route path="/dashboard/application-form" element={<Application />} /> */}
          <Route path="/dashboard/registration-data" element={<Registration2 />} />
          <Route path="/dashboard/registration-data-skill" element={<RegistrationSkill />} />
          <Route path="/dashboard/district-registration-data" element={<RegistrationFilter />} />
          <Route path="/dashboard/admin-registration-data" element={<AdminApplicationView/>} />
          <Route path="/dashboard/admin-registration-data-skill" element={<AdminApplicationSkillView/>} />
          <Route path="/dashboard/hq/home" element={<HqHome/>} />
          <Route path="/dashboard/hq/registration-data" element={<HqRegData/>} />
          <Route path="/dashboard/hq/hq-registration-data" element={<HqRegDataFilter/>} />
          <Route path="/dashboard/hq/admin-registration-data" element={<HodApplicationView/>} />
          <Route path="/dashboard/hq/dsaswo-management" element={<DsaswoManagement/>} />
          <Route path="/dashboard/capf-registration" element={<CapfRegistration />} />
          <Route path="/dashboard/esm-registration" element={<EsmRegistration />} />
          <Route path="/dashboard/skill-courses" element={<SkillCourses />} />
          
        </Route>
        <Route path="/" element={<Home />} />
        <Route path="/definition" element={<Definition />} />
        <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/whoWho" element={<WhoWho />} />
        <Route path="/actsRules" element={<ActsRules />} />
        <Route path="/sainikSchool" element={<SainikSchool />} />
        <Route path="/rmsBangalore" element={<RmsBangalore />} />
        <Route path="/rmsDholpur" element={<RmsDholpur />} />
        <Route path="/rmsAjmer" element={<RmsAjmer />} />
        <Route path="/rmsChail" element={<RmsChail />} />
        <Route path="/sainikSchool" element={<SainikSchool />} />
        <Route path="/rimc" element={<RimcInfo />} />
        <Route path="/rmsGothra" element={<SainikSchoolGothraTappaKhori />} />
        <Route path="/dsr" element={<Dsr />} />
        <Route path="/rmsKhera" element={<RmsKhera />} />
        <Route path="/rmsKunjpura" element={<SainikSchoolKunjpura />} />
        <Route path="/rmsAsthal" element={<SainikSchoolAsthal/>} />
        <Route path="/rmsMajra" element={<SainikSchoolMajra/>} />
        <Route path="/SainikSadan" element={<SainikSadan />} />
        <Route path="/organisation" element={<Organisation />} />
        <Route path="/SainikRestHouses" element={<SainikRestHouses />} />
        <Route path="/donationpage" element={<DonationPage />} />

        <Route path="/introduction" element={<Introduction />} />
        <Route path="/war-memorials" element={<WarMemorials />} />
        <Route path="/adminstrative-setup" element={<AdministrativeSetup />} />
        <Route path="/notification-order" element={< NotificationOrder />} />
        <Route path="/budget-finance" element={< BudgetFinance />} />
        <Route path="/capf" element={< Capf />} />
        <Route path="/esm" element={< Esm />} />
        <Route path="/esm-martyrs" element={< EsmMartyrs />} />
        <Route path="/capf-martyrs" element={< CapfMartyrs />} />
        <Route path="/capf-registration-district-counts" element={<CapfRegistrationDistrictCounts />} />
        <Route path="/right-information" element={< RightInformation />} />
        <Route path="/mandatory-disclosure" element={< MandatoryDisclosure />} />
        <Route path="/right-service" element={< RightService />} />
        <Route path="/canteen-stores" element={< CanteenStores />} />
        <Route path="/echs" element={< Echs />} />
        {/* <Route path="/forms" element={< Forms />} /> */}
        <Route path="/esm-awardees" element={< EsmAwardees />} />
        <Route path="/capf-awardees" element={< CapfAwardees />} />
        {/* <Route path="/grievances" element={< Grievances />} /> */}
        <Route path="/awards-esm/:districtName" element={<EsmMedalDetail />} />
        <Route path="/awards-capf/:districtName" element={<CapfMedalDetail />} />
        <Route path="/district-esm/:districtName" element={<EsmMartyrsDetails />} />
        <Route path="/district-capf/:districtName" element={<CapfMartyrsDetails />} />
        <Route path="/welfare-schemes" element={< WelfareScheme />} />
        <Route path="/capf-id-card" element={< IdCard />} />
        
        <Route path="/policy" element={< Policies />} />
        <Route path="/reservation" element={< Reservation />} />
        <Route path="/notices" element={< Notice />} />
        <Route path="/brochure" element={< Brochure />} />
        <Route path="/capf-policy" element={<Policy />} />
        <Route path="/amalgamated" element={<Amalgamated />} />
        <Route path="/ranks" element={<Ranks />} />
        <Route path="/nalsa" element={<Nalsa />} />
        <Route path="/media" element={<Media />} />
        {/* <Route path="/skill-info" element={<SkillCoursesPage />} /> */}
        <Route path="/capf-registration-info" element={<CapfRegistrationPage />} />
        <Route path="/register" element={<Register />} />
        
        {/* <Route path="/esm-registration-info" element={<EsmRegistrationPage />} /> */}
        
        
        <Route path="*" element={<NotFound />} />
      </Routes>{" "}


      {!hideLayout && (<>
        <div className={hasScrollbar ? "no-scrollbar" : "bottom-zero"}>
        </div>
        <Footer className="footer" />
      </>
      )}
            <ToastContainer position="top-center" hideProgressBar="true"
      />
    </>
  );
}
function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
